import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  text-decoration: underline;\n  &&&&&& {\n    color: ', ';\n  }\n'], ['\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  text-decoration: underline;\n  &&&&&& {\n    color: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']);

import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { TextAreaAutosize, Tooltip } from '../../..';
import Field from '../../components/Field';
import Icon from '../../../Icon';
import { styles, translations } from 'gipsy-misc';

var ReviewInputLink = function (_PureComponent) {
  _inherits(ReviewInputLink, _PureComponent);

  function ReviewInputLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReviewInputLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReviewInputLink.__proto__ || Object.getPrototypeOf(ReviewInputLink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focus: false
    }, _this.onBlur = function () {
      _this.setState({
        focus: false
      });
    }, _this.onFocus = function () {
      _this.setState({
        focus: true
      });
    }, _this.onClick = function () {
      if (!_this.props.editable) {
        return;
      }
      _this.setState({
        focus: true
      });
    }, _this.goToLink = function (e) {
      var value = _this.props.value;

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (value.startsWith('http')) {
        window.open(value);
      } else {
        window.open('//' + value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReviewInputLink, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mode = _props.mode,
          onChange = _props.onChange,
          onSubmit = _props.onSubmit,
          value = _props.value,
          noPadding = _props.noPadding,
          backgroundHover = _props.backgroundHover,
          editable = _props.editable;
      var focus = this.state.focus;


      if (!editable && !value) {
        return null;
      }

      var icon = 'Link';
      var label = translations.task.reviewInputLink.fieldLabel;

      var displayInput = focus;
      var displayLabel = !focus && !value;
      var displayValue = !focus && value;

      return React.createElement(
        Field,
        {
          mode: mode,
          className: 'active',
          onClick: this.onClick,
          noPadding: noPadding,
          backgroundHover: backgroundHover },
        React.createElement(
          'div',
          { className: 'gp-layout click-field row' },
          (displayValue || displayLabel) && React.createElement(
            'div',
            { className: 'field-label' },
            React.createElement(
              TooltipContainer,
              null,
              React.createElement(Icon, { className: 'label-icon', icon: icon }),
              React.createElement(Tooltip, { text: translations.task.reviewInputLink.tooltip, position: 'bottom right', vs: 20, hs: 20 })
            ),
            displayLabel && React.createElement(
              'span',
              { className: 'label-text' },
              label
            ),
            displayValue && React.createElement(
              Fragment,
              null,
              React.createElement(
                CustomLink,
                {
                  className: 'label-text',
                  href: value,
                  onClick: this.goToLink,
                  target: '_blank',
                  editable: editable },
                value
              ),
              editable && React.createElement(Icon, { className: 'label-icon', icon: 'Edit', style: { marginLeft: '10px' } })
            )
          ),
          displayInput && React.createElement(TextAreaAutosize, {
            placeholder: translations.task.reviewInputLink.placeholder,
            onSubmit: onSubmit,
            paramName: 'reviewInputLink',
            value: value,
            onChange: onChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            ref: function ref(_ref2) {
              _this2.input = _ref2;
            }
          })
        )
      );
    }
  }]);

  return ReviewInputLink;
}(PureComponent);

ReviewInputLink.propTypes = {
  mode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  value: PropTypes.string,
  noPadding: PropTypes.bool,
  backgroundHover: PropTypes.string,
  editable: PropTypes.bool
};
ReviewInputLink.defaultProps = {
  editable: true
};


var CustomLink = styled.span(_templateObject, function (props) {
  return props.editable ? null : styles.colors.primaryColor;
});

var TooltipContainer = styled.div(_templateObject2);

export default ReviewInputLink;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/ReviewInputLink/index.js
// module id = 310
// module chunks = 0